import Parser from 'html-react-parser';
import { ReactNode } from 'react';

import { replaceLandingRedirects } from './landingRedirects';

export const applySEOAdjustments = (html: string) => {
  return replaceLandingRedirects(
    /* TODO optimize this replaceAll
      likely with 
      
      replace(
        /<a\s+href="(?:https:\/\/www\.finn\.com)?\/de-DE(?:\/abo)?">Auto Abo(?: von FINN)?<\/a>/g,
        '<a href="/de-DE/auto-abo">Auto Abo</a>',
      )
      
      but it requires some testing and tests adding, so in not now
    */
    html
      ?.replaceAll(
        '<a href="https://www.finn.com/de-DE/abo">Auto Abo</a>',
        '<a href="https://www.finn.com/de-DE/auto-abo">Auto Abo</a>'
      )
      ?.replaceAll(
        '<a href="/de-DE/abo">Auto Abo</a>',
        '<a href="/de-DE/auto-abo">Auto Abo</a>'
      )
      ?.replaceAll(
        '<a href="https://www.finn.com/de-DE">Auto Abo</a>',
        '<a href="https://www.finn.com/de-DE/auto-abo">Auto Abo</a>'
      )
      ?.replaceAll(
        '<a href="/de-DE">Auto Abo</a>',
        '<a href="/de-DE/auto-abo">Auto Abo</a>'
      )
      ?.replaceAll(
        '<a href="/de-DE">Auto Abo von FINN</a>',
        '<a href="/de-DE/auto-abo">Auto Abo</a>'
      )
      ?.replaceAll(
        '<a href="https://www.finn.com/de-DE">Auto Abo von FINN</a>',
        '<a href="https://www.finn.com/de-DE/auto-abo">Auto Abo</a>'
      )
      ?.replaceAll(
        '<a href="/de-DE">Auto Abo von FINN.</a>',
        '<a href="/de-DE/auto-abo">Auto Abo</a>'
      )
      ?.replaceAll(
        '<a href="https://www.finn.com/de-DE">Auto Abo von FINN.</a>',
        '<a href="https://www.finn.com/de-DE/auto-abo">Auto Abo</a>'
      )
      // auto replace h tags that should not be h tag, just look like h tag
      ?.replace(
        /<h1p\b[^>]*>([\s\S]*?)<\/h1p>/gi,
        '<p class="!mobile-t1-semibold md:!web-t1-semibold before:hidden after:hidden">$1</p>'
      )
      ?.replace(
        /<h2p\b[^>]*>([\s\S]*?)<\/h2p>/gi,
        '<p class="!mobile-t2-semibold md:!web-t2-semibold before:hidden after:hidden">$1</p>'
      )
      ?.replace(
        /<h3p\b[^>]*>([\s\S]*?)<\/h3p>/gi,
        '<p class="!mobile-t3-semibold md:!web-t3-semibold before:hidden after:hidden">$1</p>'
      )
      ?.replace(
        /<h4p\b[^>]*>([\s\S]*?)<\/h4p>/gi,
        '<p class="!mobile-t4-semibold md:!web-t4-semibold before:hidden after:hidden">$1</p>'
      )
  );
};

// Parser method throw an error when the content not a string
// This function jus to catch the error to prevent the broken pages
export const parseToHtml = (
  htmlContent: string
): ReactNode | ReactNode[] | string => {
  try {
    return Parser(applySEOAdjustments(htmlContent)) as unknown as
      | ReactNode
      | ReactNode[];
  } catch (e) {
    return '';
  }
};

export const getAnchorTarget = (href: string) => {
  return href.startsWith('http') ? '_blank' : '_self';
};

const SCROLL_TOP_OFFSET = 30;
export const scrollToTarget = (
  target: HTMLElement | null,
  topOffsetOverride?: number
) => {
  if (!target) return;
  const targetPosition = target.getBoundingClientRect().top;
  const offsetPosition =
    targetPosition + window.scrollY - (topOffsetOverride ?? SCROLL_TOP_OFFSET);
  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};

export const scrollToTopWithoutAnimation = () => {
  window.scrollTo({
    top: 0,
    behavior: 'auto',
  });
};

export const targetElementTopAboveViewport = (
  target: HTMLElement | null
): boolean | null => {
  if (!target) {
    return null;
  }
  const targetTop = target.getBoundingClientRect().top;
  if (targetTop < 0) {
    return true;
  }

  return false;
};

export const targetElementTopBeyondThreshold = (
  target: HTMLElement | null,
  thresholdPercentage = 50
): boolean | null => {
  if (!target) {
    return null;
  }
  const targetTop = target.getBoundingClientRect().top;
  const windowHeight = window.innerHeight;
  const targetTopPercentage = (targetTop * 100) / windowHeight;

  // if thresholdPercentage is 50, then targetTopPercentage needs to be
  // greater than 50 to be beyond the threshold which will trigger the auto scroll
  return targetTopPercentage > thresholdPercentage;
};
